import { render } from "./SalesOverview.vue?vue&type=template&id=27211cf6&scoped=true"
import script from "./SalesOverview.vue?vue&type=script&lang=js"
export * from "./SalesOverview.vue?vue&type=script&lang=js"

import "./SalesOverview.vue?vue&type=style&index=0&id=27211cf6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27211cf6"]])

export default __exports__